export default {
    GRAPHQL_ENDPOINT: process.env.REACT_APP_NODE_URL,
    GRAPHQL_SUBSCRIPTION_ENDPOINT: process.env.REACT_APP_NODE_URL_WSS,
  }